import React from 'react';
import { Button } from '../../design-system/Button';

interface MarketingStepProps {
  onComplete: () => void;
  onSkip?: () => void;
  progress?: any;
}

const MarketingStep: React.FC<MarketingStepProps> = ({ onComplete, onSkip }) => {
  return (
    <div className="space-y-6">
      <div className="text-center py-8">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Marketing Profile
        </h3>
        <p className="text-gray-600 mb-6">
          Create your public-facing profile to attract clients.
        </p>
        <p className="text-sm text-gray-500">
          This step is optional. You can complete it later from your profile settings.
        </p>
      </div>

      <div className="flex justify-end gap-4">
        {onSkip && (
          <Button onClick={onSkip} variant="secondary" size="lg">
            Skip for Now
          </Button>
        )}
        <Button onClick={onComplete} size="lg">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default MarketingStep;